<div class="h-screen flex flex-col items-center md:justify-center">
    <div class="text-center w-full">
        <p class="md:mb-6 text-center w-full mt-4 "><span class="text-6xl text-black font-extrabold md:me-5"><span class="tracking-widest text-lrpTicketBlue">LRP</span> Tickets</span><span class="hidden md:inline-block"> | The Portal To Adventure |</span></p>
        <p class="text-center w-full mb-10 md:hidden text-lrpTicketBlack text-2xl tracking-wider">| The Portal To Adventure |</p>
        <p class="italic">Our new website is coming soon!</p>
    </div> 
    <div class="flex flex-col w-3/4 md:w-1/5" [formGroup]="loginProfile">
        <div class="text-center text-xs mt-32 mb-4">For preview, please log in</div>
        <label class="relative w-full mx-auto mb-3" for="email">
                    <fa-icon [icon]="['fas','user']" class="absolute px-2 mt-[2px]" />
            <input class="no-tracking !ps-10 !w-full" type="email" id="email" placeholder="E-mail Address" formControlName="email" required />
        </label>
        <label class="w-full mx-auto mb-3 relative" for="password">
            <fa-icon [icon]="['fas','lock']" class="absolute px-2 mt-[2px]" />
            <input class="no-tracking !ps-10 !w-full" id="password" type="password" placeholder="Password" formControlName="password" required (keydown.enter)="performLogin()"/>
        </label>
        
        <button class="primaryButton mt-3" [disabled]="loginProfile.invalid" (click)="performLogin()">Log In</button>
        <div class="flex-col flex justify-center gap-2 mt-3">
            <div class="flex flex-col items-center">
                <div id="g_id_onload"
                    data-client_id="837580855964-39evao1b96qik2juokcegr0nm4mbkl40.apps.googleusercontent.com"
                    data-context="signin"
                    data-ux_mode="popup"
                    data-login_uri="/api/auth/google"
                    data-auto_prompt="false">
                </div>

                <div class="g_id_signin hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out"
                    data-type="standard"
                    data-shape="rectangular"
                    data-theme="outline"
                    data-text="signin_with"
                    data-size="large"
                    data-logo_alignment="left"
                    data-width="250">
                </div>
            </div>
            <button (click)="signInWithFB()" class="cursor-pointer mx-auto max-w-[250px] min-w-[250px] bg-[#0866ff] text-white text-sm h-10 w-full rounded-md hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out">
                <div class="flex gap-4 ps-8">
                    <i class="pi pi-facebook scale-125 mt-[10px] me-3"></i>
                    <p class="my-2 font-semibold">Sign In with Facebook</p>
                </div>        
            </button>
            <button (click)="signInWithMicrosoft()" class="cursor-pointer mx-auto max-w-[250px] min-w-[250px] bg-white] border text-sm h-10 w-full rounded-md hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out">
                <div class="flex gap-4 ps-6">
                    <img class="scale-75" width="32px" src="assets/ms-symbollockup_mssymbol_19.png" alt="">
                    <p class="my-2 font-semibold">Sign In with Microsoft</p>
                </div>        
            </button>

        </div>
    </div> 
    <p-message styleClass="mx-3 my-3" />
</div>